import circle from './circle.svg';
import background from './background.webp';
import './App.css';
import SearchPage from './Components/SearchPage';
import Spell from './Components/Spell';
import { BrowserRouter, Routes, Route} from "react-router";
import {React, useState, useEffect} from 'react';
import PageHeader from './Components/Header/PageHeader';



function App() {
  const   [   spellList,          setSpellList          ]   =   useState([]);
  const   [   searchFilters,   setSearchFilters   ]   =   useState({
    "class"       :   "wiz",
    "level-lo"    :   "0",
    "level-hi"    :   "9",
    "school"      :   "",
    "subschool"   :   "",
    "tag"         :   [],
    "verbal"      :   false,
    "somatic"     :   false,
    "material"    :   false,
    "cost"        :   false,
    "spellFocus"  :   false,
    "divineFocus" :   false,
  })



  useEffect(() => {

  })



  return (

    <BrowserRouter>
              <PageHeader/>
      <div className="App" style={{ backgroundImage: `url(${background})`}}>
        <header className="App-header">
          <img src={circle} className="App-logo" alt="logo" />
        </header>
        <div className="App-body">

          <Routes>
              <Route path="/" element={<SearchPage spellList={spellList} setSpellList={setSpellList} searchFilters={searchFilters} setSearchFilters={setSearchFilters}/>} />
              <Route path="/spell/:spellId" element={<Spell/>}/>
            </Routes>
        </div>
        <footer>
          <br/><br/>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;